import { useTranslations } from 'next-intl';
import { buildRoute, DataTestConfig } from '@headless-workspace/config';
import { GlowButton, GlowTextBody, GlowTitle, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ConnectionBannerNotConnectedGreetingProps = PropsWithLocale & {
    isMySephoraActivated: boolean;
};

export const ConnectionBannerNotConnectedGreeting: Component<ConnectionBannerNotConnectedGreetingProps> = ({
    locale,
    isMySephoraActivated,
}) => {
    const t = useTranslations('Header.connection');

    return (
        <>
            <GlowTitle text={t('banner.label.greeting')} fontSize={'title4'} />
            <GlowTextBody text={isMySephoraActivated ? t('banner.label.infoMySephora') : t('banner.label.info')} />
            <GlowButton
                className={'self-stretch transition-backgroundOutline'}
                label={t('banner.action.loginOrRegister')}
                href={buildRoute(locale, 'connection')}
                variant={'primary'}
                dataTestId={DataTestConfig.testIds.connectionBannerLoginButton}
            />
        </>
    );
};
